import React from 'react';
import { Popup } from 'semantic-ui-react';
import styles from './tooltip.css';

const availableStyleProps = {
    borderRadius: '10px',
    padding: '.3rem 0',
    boxShadow: '0 12px 14px 0 rgba(0, 0, 0, 0.15), 0 2px 4px 0 rgba(0, 0, 0, 0.23)',
    fontSize: '16px'
};

/**
 *
 * @type {React.NamedExoticComponent<{onClose?: *, verticalOffset?: *, open?: *, position?: *, horizontalOffset?: *, onOpen?: *, content?: *, trigger?: *}>}
 */

const Tooltip = React.memo( ( { trigger, content, position, open, onClose, onOpen } ) => (
    <Popup
        open={ open }
        onClose={ onClose }
        onOpen={ onOpen }
        trigger={ trigger }
        on='click'
        hideOnScroll
        style={ availableStyleProps }
        className={ styles.wrapper }
        position={ position ? position : 'bottom right' }

    >
        <Popup.Content>{ content }</Popup.Content>
    </Popup>
) );

export default Tooltip;
